// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/persons.bundle.scss
// module id = 521
// module chunks = 1